import config from '../../../config';
import { SpriteToRect, debounce } from '../../../utils';

let soundManager;

let playNaniteSound = debounce(function () {
  soundManager.playSound('nanite-cycle');
}, 250, true);

function initNaniteExpanders (layer) {
  let g = this.g;
  soundManager = g.scene.get('SoundManager');
  layer.groups.tiles.sort(function (a, b) {
    if (a.y === b.y) {
      return a.x - b.x;
    }
    return a.y - b.y;
  });
  _.each(layer.groups.tiles, (sprite, i) => {
    let odd = i % 2;
    let startDelay = config.EXPANDERS_DELAY + config.EXPANDERS_INTERVAL * odd;
    sprite.timer = g.time.delayedCall(startDelay, () => {
      expandNanite.call(this, sprite);
    });
  });
}

function expandNanite (sprite) {
  let g = this.g;
  sprite.play('nanite-expander-open');
  sprite.once('animationcomplete', () => {
    sprite.play('nanite-expander-rotate');
    sprite.once('animationcomplete', () => {
      sprite.play('nanite-expander-close');
      sprite.once('animationcomplete', () => {
        sprite.timer = g.time.delayedCall(config.EXPANDERS_INTERVAL, () => {
          expandNanite.call(this, sprite);
        });
      });
    });
  });
  let cameraRect = new Phaser.Geom.Rectangle(0, g.cameras.main.scrollY, config.WIDTH, config.HEIGHT);
  let spriteRect = SpriteToRect(sprite);
  if (Phaser.Geom.Intersects.RectangleToRectangle(cameraRect, spriteRect)) {
    playNaniteSound();
  }
}

export {
  initNaniteExpanders
};
